import React from 'react'

interface IDropdownProps {
    buttonTitle?: string
    buttonElements: any
    dropdownContent: any
    showMenu: boolean
    onShow?: () => void
    setShowMenu: (showMenu: boolean) => void
}

class Dropdown extends React.PureComponent<IDropdownProps> {
    private dropdownMenuRef: React.RefObject<HTMLDivElement>

    constructor(props: any) {
        super(props);
        this.dropdownMenuRef = React.createRef()
    }

    handleCloseMenu = (e: MouseEvent) => {
        if (this.dropdownMenuRef.current && !this.dropdownMenuRef.current.contains(e.target as HTMLElement)) {
            document.removeEventListener('click', this.handleCloseMenu)
            this.props.setShowMenu(false)
        }
    }

    handleShowMenu = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        this.props.setShowMenu(true)
        document.addEventListener('click', this.handleCloseMenu);
        if (this.props.onShow) this.props.onShow()
    }

    render() {
        return (
            <div className={'dropdown-wrapper'}>
                <button title={this.props.buttonTitle} onClick={this.handleShowMenu} disabled={this.props.showMenu}>
                    {this.props.buttonElements}
                </button>
    
                {
                    this.props.showMenu ?
                    <div ref={this.dropdownMenuRef}
                        className="dropdownMenu"
                    >
                        {this.props.dropdownContent}
                    </div> : null
                }
            </div>
        )
    }
}

export default Dropdown;